<div class="form-group">
  <label><em>{{ label }}</em></label>
  <quill-editor ngModel="{{_value}}" [styles]="{ height: '100px' }" maxlength="5000" (onEditorChanged)="changedEditor($event)"></quill-editor>
</div>
